import { cva } from 'class-variance-authority';

import {
  textColorVariants,
  statusTextVariants,
  typographyTextSizes,
  lineHeightVariants,
  fontWeightVariants,
  textAlignVariants,
  letterSpacingVariants,
  fontFamilyVariants,
  textTransformVariants,
  truncateClasses,
} from '@/lib/shared-variants';

/**
 * Typography variant styles using class-variance-authority
 * Uses shared variants from the design system for consistency
 */
export const typographyVariants = cva('', {
  variants: {
    variant: {
      // Display & Headings
      display: `${typographyTextSizes.display} ${lineHeightVariants['1.1']} ${fontWeightVariants.bold}`,
      h1: `${typographyTextSizes.h1} ${lineHeightVariants['1.1']} ${fontWeightVariants.bold}`,
      h2: `${typographyTextSizes.h2} ${lineHeightVariants['1.2']} ${fontWeightVariants.bold}`,
      h3: `${typographyTextSizes.h3} ${lineHeightVariants['1.3']} ${fontWeightVariants.semibold}`,
      h4: `${typographyTextSizes.h4} ${lineHeightVariants['1.25']} ${fontWeightVariants.semibold}`,
      h5: `${typographyTextSizes.h5} ${lineHeightVariants['1.3']} ${fontWeightVariants.semibold}`,
      h6: `${typographyTextSizes.h6} ${lineHeightVariants['1.35']} ${fontWeightVariants.semibold}`,

      // Body text
      'body-large': `${typographyTextSizes['body-large']} ${lineHeightVariants['1.625']} ${fontWeightVariants.normal}`,
      body: `${typographyTextSizes.body} ${lineHeightVariants['1.625']} ${fontWeightVariants.normal}`,
      'body-small': `${typographyTextSizes['body-small']} ${lineHeightVariants['1.5']} ${fontWeightVariants.normal}`,

      // Utility text
      caption: `${typographyTextSizes.caption} ${lineHeightVariants['1.4']} ${fontWeightVariants.normal}`,
      overline: `${typographyTextSizes.overline} ${lineHeightVariants['1.4']} ${fontWeightVariants.medium} ${textTransformVariants.uppercase} ${letterSpacingVariants.overline}`,

      // Specialized
      label: `${typographyTextSizes.label} ${lineHeightVariants['1.5']} ${fontWeightVariants.medium}`,
      code: `${typographyTextSizes.code} ${lineHeightVariants['1.5']} ${fontFamilyVariants.mono}`,
    },
    weight: {
      light: fontWeightVariants.light,
      regular: fontWeightVariants.normal,
      medium: fontWeightVariants.medium,
      bold: fontWeightVariants.bold,
    },
    align: {
      left: textAlignVariants.left,
      center: textAlignVariants.center,
      right: textAlignVariants.right,
      justify: textAlignVariants.justify,
    },
    color: {
      primary: textColorVariants.primary,
      secondary: textColorVariants.secondary,
      tertiary: textColorVariants.tertiary,
      brand: statusTextVariants.brand,
      link: textColorVariants.link,
      success: statusTextVariants.success,
      warning: statusTextVariants.warning,
      danger: statusTextVariants.danger,
      info: statusTextVariants.info,
    },
    truncate: {
      true: truncateClasses,
      false: '',
    },
  },
  defaultVariants: {
    variant: 'body',
    color: 'primary',
    truncate: false,
  },
});
